import { Reveal } from "../common/Reveal";
import { CTAButton } from "../common/CTAButton";
import { images } from "../../data/content";

export const FinalCTA = () => (
    <section className="relative bg-navy overflow-hidden" data-testid="final-cta">
        <div className="absolute inset-0 z-0">
            <img src={images.constructionSite} alt="" aria-hidden className="w-full h-full object-cover opacity-20" />
            <div className="absolute inset-0 bg-navy/85" />
        </div>
        <div className="absolute inset-0 z-[1] bg-grid opacity-50" />
        <div className="relative z-10 mx-auto max-w-[1100px] px-5 lg:px-10 py-24 lg:py-36 text-center">
            <Reveal>
                <span className="text-xs uppercase tracking-[0.28em] font-semibold text-brand">Let's Build Together</span>
            </Reveal>
            <Reveal delay={0.05}>
                <h2 className="mt-6 font-display font-extrabold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
                    Ready to Build Your Workforce or Project?
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <p className="mt-6 max-w-2xl mx-auto text-slate-300 text-base lg:text-lg leading-relaxed">
                    Whether you need 10 employees or a large-scale project workforce, FRONTX can help you
                    plan, recruit, deploy and manage the required workforce.
                </p>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                    <CTAButton to="/contact#manpower" variant="primary" data-testid="final-request-manpower">Request Manpower</CTAButton>
                    <CTAButton to="/contact#construction" variant="light" data-testid="final-construction-quote">Get Construction Quote</CTAButton>
                </div>
            </Reveal>
        </div>
    </section>
);
